export default __webpack_public_path__ + "media/images/30-c882bbcdbe7d3f3922b90920e46682d1.jpg";